import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { useMemo } from 'react';
import { mapRedirectTargetToRoute, mapRedirectTargetToRouteFromApiName } from 'self-service-api/core/utilities/links';
import { SURVEY_OPTIONS_BY_UPGRADE_PRODUCT } from 'ui-addon-upgrades/_core/common/constants/trials';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { shuffle } from '../../../utils';
import { navigateTo } from '../../common/navigation/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'upgrades.activationModal';
const TrialRedirectSurvey = ({
  upgradeData,
  upgradeData: {
    upgradeProduct,
    apiName
  }
}) => {
  const surveyOptions = useMemo(() => shuffle(SURVEY_OPTIONS_BY_UPGRADE_PRODUCT[upgradeProduct]), [upgradeProduct]);
  const handleRedirect = value => {
    track('trialActivationRedirected', Object.assign({
      redirectTarget: value
    }, getUpgradeDataTrackingProperties(upgradeData), {
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    if (apiName) {
      navigateTo(mapRedirectTargetToRouteFromApiName(value, apiName));
    } else {
      navigateTo(mapRedirectTargetToRoute(value, upgradeProduct));
    }
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "600",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx("h5", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${LANG_ROUTE}.featureExplore`
      })
    }), /*#__PURE__*/_jsxs(List, {
      wrapChildren: true,
      children: [surveyOptions.map(option => /*#__PURE__*/_jsx(SelectableButton, {
        marginBlockEnd: "200",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.survey.${option}.description`
        }),
        block: true,
        name: option,
        truncatable: false,
        onClick: () => handleRedirect(option)
      }, option)), /*#__PURE__*/_jsx(SelectableButton, {
        marginBlockEnd: "200",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.survey.ownExplore`
        }),
        block: true,
        name: "other",
        truncatable: false,
        onClick: () => handleRedirect('other')
      })]
    })]
  });
};
export default TrialRedirectSurvey;